//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
import { NsIcon } from '@nuskin/ns-icon';
/**
 * This component is a lightbox that will auto-start playing a video and pause
 * it when closed
 *
 * @event close Fired when the user signals the lightbox should to be closed.
 */
export default {
  name: 'NsLightbox',
  components: { NsIcon },
  props: {
    /**
     * The abbreviated label for the escape button. Limit is 3 chars
     */
    escLabel: {
      type: String,
      default: '',
    },
    /**
     * The open state of the lightbox
     */
    open: Boolean,
    /**
     * The video source url
     */
    videoSrc: {
      type: String,
      default: '',
    },
    /**
     * Source tags can be used instead of ctaUrl
     */
    videoSrcTags: {
      type: String,
      default: '',
    },
  },
  watch: {
    open(value) {
      if (value) {
        window.addEventListener('keydown', this.handleKeydown);
        this.$refs.lightboxVideo.play();
      } else {
        window.removeEventListener('keydown', this.handleKeydown);
        this.$refs.lightboxVideo.pause();
      }
    },
    videoSrc() {
      this.$refs.lightboxVideo.load();
    },
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    /**
     * Closes lightbox if Escape key is pressed
     * Toggles play/pause if spacebar is pressed
     */
    handleKeydown(event) {
      // Closes lightbox if Escape key is pressed
      if (event.key === 'Escape') {
        this.handleCloseLightbox();
      }

      // Toggles play/pause if spacebar is pressed
      if (event.key === ' ') {
        this.toggleVideo();
      }
    },
    /**
     * Closes lightbox
     */
    handleCloseLightbox() {
      this.$emit('close');
    },
    /**
     * Toggles play and pause
     */
    toggleVideo() {
      if (this.$refs.lightboxVideo.paused) {
        this.$refs.lightboxVideo.play();
      } else {
        this.$refs.lightboxVideo.pause();
      }
    },
  },
};
